import FastMarquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const ITEMS = [
  "Crystal Clear",
  "Billings, MT",
  "Premium Quality",
  "Residential & Commercial",
  "Streak-Free Guarantee",
];

export const Marquee = () => {
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="border-y border-zinc-200 bg-sky-50/60 py-6"
    >
      <FastMarquee speed={28} gradient={false}>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="mx-10 flex items-center gap-20 font-display text-2xl font-light uppercase tracking-[0.2em] text-zinc-800 md:text-3xl"
          >
            {item}
            <Sparkles className="h-5 w-5 text-sky-500" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
};
